import React, {createContext, useState} from 'react';
import {getErrorMessage} from "../../helpers/Utils";
import {Toast} from "../../components/common/Toast";
import CategoryService from "../../services/product/CategoryService";

export const CategoryContext = createContext("CategoryContext");

const CategoryContextProvider = ({children}) => {

    const [loading, setLoading] = useState(false);
    const [totalElements, setTotalElements] = useState(0);
    const [categoryList, setCategoryList] = useState([]);
    const [categoryListForBranch, setCategoryListForBranch] = useState([]);

    const [categoryListForOurMenu, seCategoryListForOurMenu] = useState([]);

    const getAllCategory = async params => {
        try {

            setLoading(true);

            const res = await CategoryService.getAllCategory(params);
            setCategoryList(res.data.content);
            setTotalElements(res.data.totalElements);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);
            // Toast("error", "Error", message);

        }
    }

    const getAllCategoryForBranch = async params => {
        try {

            setLoading(true);

            const res = await CategoryService.getAllCategoryForBranch(params);
            setCategoryListForBranch(res.data.content);
            setTotalElements(res.data.totalElements);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);
            // Toast("error", "Error", message);

        }
    }

    const getAllCategoryForOurMenu = async params => {
        try {

            setLoading(true);

            const res = await CategoryService.getAllCategoryForOurMenu(params);
            seCategoryListForOurMenu(res.data);

            setLoading(false);

        } catch (error) {

            setLoading(false);

            const message = getErrorMessage(error);
            Toast("error", "Error", message);

        }
    }

    return (
        <CategoryContext.Provider
            value={{
                loading,
                totalElements,
                categoryList,
                categoryListForBranch,
                getAllCategoryForBranch,
                getAllCategory,
                getAllCategoryForOurMenu,
                categoryListForOurMenu,
            }}
        >
            {children}
        </CategoryContext.Provider>
    );
}

export default CategoryContextProvider;
